import React, { Component } from 'react'
import moment from 'moment';
import { Dropdown, DropdownButton } from 'react-bootstrap';

import SearchInput from '../../../../facturotopia/search-input/SearchInput';
import CalendarDateRangePicker from '../../../../facturotopia/calendar-date-range-picker/CalendarDateRangePicker';

class CancelacionesTicketsSearch extends Component {

  state = {}

  constructor(props) {
    super(props);

    const { from: asFrom, to: asTo } = this.props;

    const from = !!asFrom ? moment(asFrom): moment().subtract(7, 'days');
    const to =  !!asTo ? moment(asTo) : moment();

    this.state = {
      date: [
        from.toDate(),
        to.toDate()
      ]
    }
  }

  handleOnKeywordChange = (keyword) => {
    this.handleOnSearch(keyword, this.state.index);
  }

  handleOnSearchClear = () => {
    this.handleOnKeywordChange('');
  }

  handleOnDateChange = (date) => {
    const from = moment(date[0]);
    const to = moment(date[1]);

    this.props.onDateChange({
      page: 1,
      from: from.format('YYYY-MM-DD'),
      to: to.format('yyyy-MM-DD')
    });

    this.setState({ date });
  }

  getOmnisearchLegend = () => {
    const { index } = this.state;

    let legend = 'Omnisearch';

    switch (index) {
        case 'cfdi_uuid':
          legend = 'Folio Fiscal';
          break;
        case 'rfc_emisor':
          legend = 'Emisor RFC';
          break;
        case 'rfc_receptor':
          legend = 'Receptor RFC';
          break;
        case 'motivo':
          legend = 'Motivo';
          break;
        case 'total':
          legend = 'Total';
          break;
      default:
        break;
    }

    return legend;
  }

  handleOnSelectIndex = (name, event) => {
    const { id } = event.target;

    this.setState({
      index: id
    });

    const { search } = this.props;

    if (!!search) {
      this.handleOnSearch(search, id)
    }
  }

  handleOnSearch = (search, field) => {
    this.props.onKeywordChange({
      search,
      field
    });
  }

  render() {
    const { date } = this.state;
    const { search = '' } = this.props;

    return (
      <div className="d-flex flex-column flex-sm-row">
        <div className="pr-2 pb-2">
          <CalendarDateRangePicker
            value={ date }
            onDateChange={ this.handleOnDateChange }
          />
        </div>
        <div className="flex-fill search-container">
          <SearchInput
            onKeywordChange={ this.handleOnKeywordChange }
            onClear={ this.handleOnSearchClear }
            value={ search }
          >
            <DropdownButton
              variant="outline-secondary"
              title={ this.getOmnisearchLegend() }
              id="search-index"
              onSelect={ this.handleOnSelectIndex }
            >
              <Dropdown.Item id="">Sin filtro</Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item id="cfdi_uuid">Folio Fiscal</Dropdown.Item>
              <Dropdown.Item id="rfc_emisor">Emisor RFC</Dropdown.Item>
              <Dropdown.Item id="rfc_receptor">Receptor RFC</Dropdown.Item>
              <Dropdown.Item id="motivo">Motivo</Dropdown.Item>
              <Dropdown.Item id="total">Total</Dropdown.Item>
            </DropdownButton>
          </SearchInput>
        </div>
      </div>
    )
  }
}

export default CancelacionesTicketsSearch;